// AUDIO INFORMATION -----------------------------

export const AUDIO_TYPE = {
	TRACK: "TRACK",
	BLEND: "BLEND",
} as const;

export type AudioType = (typeof AUDIO_TYPE)[keyof typeof AUDIO_TYPE];

export const AUDIO_GROUP_TYPE = {
	ALBUM: "ALBUM",
	COLLECTION: "COLLECTION",
	CUSTOM_BLEND: "CUSTOM_BLEND",
	EFFECT: "EFFECT",
	FAVORITES: "FAVORITES",
	FREE: "FREE",
} as const;

export type AudioGroupType =
	(typeof AUDIO_GROUP_TYPE)[keyof typeof AUDIO_GROUP_TYPE];

export const COLLECTION_IDS = {
	BLEND: "collections:blends",
	BRAIN_WAVE: "collections:brain-waves",
	CAFE: "collections:cafes",
	MOODSCAPE: "collections:moodscapes",
	SOUND_COLOR: "collections:sound-colors",
	SOUNDSCAPE: "collections:soundscapes",
} as const;

export type CollectionIds =
	(typeof COLLECTION_IDS)[keyof typeof COLLECTION_IDS];

export const COLLECTION_NAMES = {
	BLEND: "Blends",
	BRAIN_WAVE: "Brain Waves",
	CAFE: "Cafés",
	CUSTOM_BLEND: "Custom Blends",
	MOODSCAPE: "Moodscapes",
	SOUND_COLOR: "Sound Colors",
	SOUNDSCAPE: "Soundscapes",
} as const;

export type CollectionNames =
	(typeof COLLECTION_NAMES)[keyof typeof COLLECTION_NAMES];

export const COLLECTION_SLUGS = {
	BLEND: "blends",
	BRAIN_WAVE: "brain-waves",
	CAFE: "cafes",
	CUSTOM_BLEND: "custom-blends",
	MOODSCAPE: "moodscapes",
	SOUND_COLOR: "sound-colors",
	SOUNDSCAPE: "soundscapes",
} as const;

export type CollectionSlugs =
	(typeof COLLECTION_SLUGS)[keyof typeof COLLECTION_SLUGS];

export const EFFECT_NAMES = {
	FOCUS: "Focus",
	RELAXATION: "Relaxation",
	STIMULATION: "Stimulation",
	CREATIVITY: "Creativity",
	ENERGY: "Energy",
	MEDITATION: "Meditation",
	MINDFULNESS: "Mindfulness",
	PRODUCTIVITY: "Productivity",
	SLEEP: "Sleep",
} as const;

export type EffectNames = (typeof EFFECT_NAMES)[keyof typeof EFFECT_NAMES];

export const EFFECT_SLUGS = {
	FOCUS: "focus",
	RELAXATION: "relaxation",
	STIMULATION: "stimulation",
	CREATIVITY: "creativity",
	ENERGY: "energy",
	MEDITATION: "meditation",
	MINDFULNESS: "mindfulness",
	PRODUCTIVITY: "productivity",
	SLEEP: "sleep",
} as const;

export type EffectSlugs = (typeof EFFECT_SLUGS)[keyof typeof EFFECT_SLUGS];

// DATABASE INFORMATION -----------------------------

export const DATABASE_NAMES = {
	AUTH: "auth",
	CORE: "core",
} as const;

export type DatabaseNames =
	(typeof DATABASE_NAMES)[keyof typeof DATABASE_NAMES];

export const CONTENT_COLLECTION_NAMES = {
	CUSTOM_BLEND: "custom-blends",
} as const;

export type ContentCollectionNames =
	(typeof CONTENT_COLLECTION_NAMES)[keyof typeof CONTENT_COLLECTION_NAMES];

// API REQUEST AND RESPONSE TYPES -----------------------------

export const API_ERROR_NAMES = {
	SERVER_ERROR: "SERVER_ERROR",
	UNAUTHORIZED: "UNAUTHORIZED",
	NOT_FOUND: "NOT_FOUND",
	BAD_REQUEST: "BAD_REQUEST",
	DAILY_LIMIT_EXCEEDED: "DAILY_LIMIT_EXCEEDED",
	// Returned when a long-lived tab sends a request shaped by a superseded
	// bundle (detected per-endpoint, e.g. a checkout body from before Checkout
	// Review). The client bundle is behind the server contract and cannot
	// self-correct; the resolution is always to refresh into the current bundle.
	CLIENT_OUTDATED: "CLIENT_OUTDATED",
} as const;

export type ApiErrorNames =
	(typeof API_ERROR_NAMES)[keyof typeof API_ERROR_NAMES];
